/* DO NOT MODIFY. This is an autogenerated file. */
/* eslint-disable */
import * as React from "react"
import type { SVGProps } from "react"

export const SvgFileZip = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 37"
    aria-label="SvgFileZip"
    width={props.width || "100%"}
    height={props.height || "100%"}
    {...props}
  >
    {props.children}
    <path
      fill="url(#file-zip_svg__a)"
      d="M29.412 36.353H2.588A2.59 2.59 0 0 1 0 33.765V2.705A2.59 2.59 0 0 1 2.588.119H20l12 12v21.647a2.59 2.59 0 0 1-2.588 2.588"
    />
    <mask
      id="file-zip_svg__b"
      width={15}
      height={8}
      x={8}
      y={18.118}
      fill="#000"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#fff" d="M8 18.118h15v8H8z" />
      <path d="m9.21 24.443 3.682-4.995H9.265v-.702h4.545v.648l-3.681 5.022h3.726v.702H9.21zm6.33-5.697h.756v6.372h-.756zm2.968 0h1.89q.441 0 .837.09.404.081.71.288.315.198.495.54.19.333.19.828 0 .522-.198.864a1.5 1.5 0 0 1-.513.54 2 2 0 0 1-.675.279q-.37.08-.703.08h-1.277v2.863h-.756zm.756 2.808h1.277q.567 0 .918-.252.36-.261.36-.801t-.36-.792q-.35-.261-.918-.261h-1.277z" />
    </mask>
    <path
      fill="#fff"
      d="m9.21 24.443 3.682-4.995H9.265v-.702h4.545v.648l-3.681 5.022h3.726v.702H9.21zm6.33-5.697h.756v6.372h-.756zm2.968 0h1.89q.441 0 .837.09.404.081.71.288.315.198.495.54.19.333.19.828 0 .522-.198.864a1.5 1.5 0 0 1-.513.54 2 2 0 0 1-.675.279q-.37.08-.703.08h-1.277v2.863h-.756zm.756 2.808h1.277q.567 0 .918-.252.36-.261.36-.801t-.36-.792q-.35-.261-.918-.261h-1.277z"
    />
    <path
      fill="#fff"
      d="m9.21 24.443-.189-.14-.046.062v.078zm3.682-4.995.189.14.276-.376h-.465zm-3.627 0h-.236v.235h.236zm0-.702v-.236h-.236v.236zm4.545 0h.235v-.236h-.235zm0 .648.19.139.045-.062v-.077zm-3.681 5.022-.19-.14-.275.375h.465zm3.726 0h.235v-.236h-.235zm0 .702v.235h.235v-.235zm-4.644 0h-.236v.235h.236zm.189-.536 3.681-4.995-.379-.279-3.68 4.995zm3.492-5.37H9.265v.471h3.627zm-3.392.236v-.702h-.47v.702zm-.235-.467h4.545v-.47H9.265zm4.31-.235v.648h.47v-.648zm.045.509-3.681 5.022.38.278 3.68-5.022zm-3.491 5.396h3.726v-.47h-3.726zm3.49-.235v.702h.47v-.702zm.236.466H9.21v.471h4.644zm-4.41.236v-.675h-.47v.675zm6.095-6.372v-.236h-.236v.236zm.756 0h.235v-.236h-.235zm0 6.372v.235h.235v-.235zm-.756 0h-.236v.235h.236zm0-6.137h.756v-.47h-.756zm.52-.235v6.372h.47v-6.372zm.236 6.136h-.756v.471h.756zm-.521.236v-6.372h-.47v6.372zm2.733-6.372v-.236h-.236v.236zm2.727.09-.053.23h.006zm.71.288-.131.195.006.004zm.495.54-.208.11.004.006zm-.009 1.692.204.118zm-.513.54-.125-.2-.002.002zm-2.654.36v-.236h-.236v.236zm0 2.862v.235h.235v-.235zm-.756 0h-.236v.235h.236zm.756-3.564h-.236v.235h.236zm2.195-.252.138.19zm0-1.593-.14.189.006.003zm-2.195-.261v-.236h-.236v.236zm-.756-.467h1.89v-.47h-1.89zm1.89 0q.416 0 .784.084l.105-.459a4 4 0 0 0-.89-.096zm.79.085q.363.074.626.253l.263-.39a2.2 2.2 0 0 0-.796-.324zm.632.257q.26.162.412.45l.417-.219a1.6 1.6 0 0 0-.578-.63zm.416.457c.1.177.158.41.158.712h.47c0-.36-.068-.678-.219-.945zm.158.712c0 .32-.06.563-.166.746l.407.236c.158-.274.23-.606.23-.982zm-.166.746a1.3 1.3 0 0 1-.435.459l.25.398q.367-.232.592-.621zm-.437.46q-.269.175-.598.247l.1.46q.41-.09.753-.312zm-.598.247q-.348.075-.652.075v.471q.361 0 .753-.087zm-.652.075h-1.277v.471h1.277zm-1.513.236v2.862h.47v-2.862zm.236 2.626h-.756v.471h.756zm-.521.236v-6.372h-.47v6.372zm.52-3.329h1.278v-.47h-1.277zm1.278 0c.412 0 .77-.092 1.056-.296l-.275-.383c-.183.132-.436.208-.78.208zm1.057-.297c.314-.228.457-.574.457-.991h-.47c0 .302-.098.49-.264.61zm.457-.991c0-.417-.143-.763-.46-.985l-.27.385c.162.114.26.297.26.6zm-.455-.981c-.285-.212-.645-.308-1.059-.308v.471c.343 0 .595.079.778.215zm-1.059-.308h-1.277v.471h1.277zm-1.513.236v2.106h.47v-2.106z"
      mask="url(#file-zip_svg__b)"
    />
    <path
      fill="url(#file-zip_svg__c)"
      fillOpacity={0.7}
      d="M32 12.118h-9.412A2.59 2.59 0 0 1 20 9.529V.118z"
    />
    <defs>
      <linearGradient
        id="file-zip_svg__a"
        x1={16}
        x2={16}
        y1={0.118}
        y2={36.353}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2E3254" stopOpacity={0.53} />
        <stop offset={1} stopColor="#282A4B" stopOpacity={0.51} />
      </linearGradient>
      <linearGradient
        id="file-zip_svg__c"
        x1={26}
        x2={26}
        y1={0.118}
        y2={12.118}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#12143D" stopOpacity={0.29} />
        <stop offset={1} stopColor="#181E5A" stopOpacity={0.39} />
      </linearGradient>
    </defs>
  </svg>
)
